import { useState } from 'react';

import { useUserStore } from 'store/useUserStore';
import { getAuthUser } from 'store/useUserStore/selectors';

export const useOnePageShareRestrictions = () => {
  const [isShareMenuOpened, setIsShareMenuOpened] = useState(false);
  const [isRestricted, setIsRestricted] = useState(false);

  const userAuth = useUserStore(getAuthUser);

  const isShareMenuAccessed = Boolean(userAuth)

  const onOpenMenu = () => {
    if (!isShareMenuAccessed) {
      setIsRestricted(true);
      return;
    }

    setIsShareMenuOpened(true);
  };
  const onClickAway = () => {
    setIsShareMenuOpened(false);
    setIsRestricted(false);
  };

  return {
    isShareMenuOpened,
    isRestricted,
    onOpenMenu,
    onClickAway,
  };
};
